import { render, staticRenderFns } from "./BeneficiaryPersonalData.vue?vue&type=template&id=5ae4d4cc&"
import script from "./BeneficiaryPersonalData.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryPersonalData.vue?vue&type=style&index=0&id=5ae4d4cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports